import { UAParser } from 'ua-parser-js'

const parser = new UAParser(window.navigator.userAgent)
const { type } = parser.getDevice()
const isBrave = !!window.navigator.brave

export const userAgent = parser.getResult()

export const isMobile = type === 'mobile' || type === 'tablet'
export const getBrowser = () => (isBrave ? 'brave' : 'all')
